import axios from "../../config/axiosConfig";
import { getSubJobIssueTransactionTakaNo } from './sub-job-issue-transaction-actions';
import { getProductions } from './production-entry-actions';
import { getProductionTransaction, getProductionTransactionTakaNo } from './production-transaction-actions';
import { CREATE_SUB_JOB_ISSUE, GET_SUB_JOB_ISSUES, SUB_JOB_ISSUE_REQUEST, UPDATE_SUB_JOB_ISSUE, DELETE_SUB_JOB_ISSUE, SUB_JOB_ISSUE_REQUEST_FAILURE } from "../types";

export const getSubJobIssues = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SUB_JOB_ISSUE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/sub-job-issue/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_SUB_JOB_ISSUES, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SUB_JOB_ISSUE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SUB_JOB_ISSUE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createSubJobIssue = (subJobIssue) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: SUB_JOB_ISSUE_REQUEST });
      const newSubJobIssue = {
        ...subJobIssue
      };
      return axios.post("/sub-job-issue/add", newSubJobIssue,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_SUB_JOB_ISSUE, payload: response.data });
          dispatch(getSubJobIssueTransactionTakaNo());
          dispatch(getProductions());
          dispatch(getProductionTransaction());
          dispatch(getProductionTransactionTakaNo());
        } else {
          dispatch({
            type: SUB_JOB_ISSUE_REQUEST_FAILURE,
            error: "Sub Job Issue create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SUB_JOB_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SUB_JOB_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateSubJobIssue = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SUB_JOB_ISSUE_REQUEST });
      const { auth } = getState();
      return axios.put("/sub-job-issue/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Company_Id || auth.company?.id,
            finyearId: data.Finyear_Id || auth.finyear?.id,
            customerId: data.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_SUB_JOB_ISSUE,
            payload: { id, data: response.data },
          });
          dispatch(getSubJobIssueTransactionTakaNo());
          dispatch(getProductions());
          dispatch(getProductionTransaction());
          dispatch(getProductionTransactionTakaNo());
        } else {
          dispatch({
            type: SUB_JOB_ISSUE_REQUEST_FAILURE,
            error: "Sub Job Issue update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SUB_JOB_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SUB_JOB_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteSubJobIssue = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SUB_JOB_ISSUE_REQUEST });
      const { auth } = getState();
      return axios.delete(`/sub-job-issue/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_SUB_JOB_ISSUE, id: id });
          dispatch(getSubJobIssueTransactionTakaNo());
          dispatch(getProductions());
          dispatch(getProductionTransaction());
          dispatch(getProductionTransactionTakaNo());
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SUB_JOB_ISSUE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SUB_JOB_ISSUE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};